import React, { useContext, useEffect } from "react";
import BlankPage from "./blank";
import DashboardModule from "./dashboard";
import useFetchData from "../../hooks/useFetchData";
import MyLoader from "../../component/loader";
import OnboardingScreen from "./onboarding";
import { AuthContext } from "../../context/authContext";

export default function Dashboard() {
  useEffect(() => {
    document.title = "Dashboard";
  }, []);

  const { data: campaigns, isLoading: campaignsLoading } = useFetchData({
    dataType: "campaigns",
  });

  const { profile } = useContext(AuthContext);
  if (profile === undefined) return <MyLoader />;
  else {
    if (campaignsLoading) return <MyLoader />;
    else if (!profile?.is_onboarding_completed)
      return <OnboardingScreen profile={profile} />;
    else
      return campaigns?.data?.length > 0 ? (
        <DashboardModule />
      ) : (
        <>
          <BlankPage />
          <div className="fixed w-full h-full top-0 xl:w-[calc(100%-278px)] right-0 z-[150] blur-lg backdrop-blur-md">
            <div className="mt-[100px]">
              <DashboardModule isEmpty />
            </div>
          </div>
        </>
      );
  }
}
